import {
  Bot,
  Users,
  LayoutDashboard,
  CreditCard,
  Globe
} from "lucide-react";

export default function Footer() {
  return (
    <footer
      dir="rtl"
      className="border-t border-white/10 bg-black/40"
    >
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row justify-between items-center gap-6">

        {/* COPYRIGHT */}
        <p className="text-sm text-slate-400">
          © {new Date().getFullYear()} دیپ‌ماین فایننس — تمامی حقوق محفوظ است.
        </p>

        {/* LINKS */}
        <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-300">

          <a
            href="/dashboard"
            className="flex items-center gap-2 hover:text-emerald-400 transition"
          >
            <LayoutDashboard size={16} />
            داشبورد
          </a>

          <a
            href="/mentors"
            className="flex items-center gap-2 hover:text-emerald-400 transition"
          >
            <Users size={16} />
            منتورها
          </a>

          <a
            href="/chat"
            className="flex items-center gap-2 hover:text-emerald-400 transition"
          >
            <Bot size={16} />
            چت هوش مصنوعی
          </a>

          <a
            href="/plans"
            className="flex items-center gap-2 hover:text-emerald-400 transition"
          >
            <CreditCard size={16} />
            پلن‌ها
          </a>

          {/* ZIATECH */}
          <a
            href="https://ziatech.ir"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-emerald-400 transition"
          >
            <Globe size={16} />
            ZiaTech
          </a>

        </div>

      </div>
    </footer>
  );
}